import * as React from 'react';
import Grid from '@material-ui/core/Grid';

import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { paymentService } from 'services/PaymentService';
import { ICartModel } from 'interfaces/ICartModel';
import FieldText from 'components/Field/Text';
import Translate from 'components/Translate';
import { enLang, IProductConfig } from 'interfaces/IProductData';
import { parameterService } from 'services/ParameterService';
import { enParameters } from 'enums/enParameters';
import { langService } from 'services/LangService';
import { cartService } from 'services/CartService';

interface IState extends IStateBase {
  model: ICartModel;
  config: IProductConfig;
  isPersonF: boolean;
  isPersonJ: boolean;
  sdoc: boolean;
  askDocument: boolean;
  lang: enLang;
  lock: boolean;
}

export default class CpfForm extends BaseComponent<IState> {

  constructor(props: any) {
    super(props);
    this.state = {
      isPersonF: false,
      isPersonJ: false,
      lang: undefined,
      lock: false,
      model: undefined,
      config: undefined,
      sdoc: false,
      askDocument: true,
    };
  }

  componentDidMount() {
    this.bindModel(paymentService.getCart());
    this.observeState( {config: null }, cartService.getConfig());
    this.observeState({ askDocument: false }, cartService.getConfig().map(config => !!config.askDocument));
    this.observeState({ isPersonF: false }, parameterService.get(enParameters.df).map(df => !!df));
    this.observeState({ isPersonJ: false }, parameterService.get(enParameters.dj).map(dj => !!dj));
    this.observeState({ sdoc: false }, parameterService.get(enParameters.sdoc).map(sdoc => !!sdoc));
    this.observeState({ lang: null }, langService.getLang());

    cartService.getCart()
      .bindComponent(this)
      .filter(cart => !!cart.user)
      .map(cart => cart.user.lock)
      .subscribe(lock => {
        this.setState({ lock });
      });
  }

  setDocument = (document: any) => {
    paymentService.setData({ document });
  }

  render() {

    if (!this.state) {
      return null;
    }

    if (!this.state.model) {
      return null;
    }

    const { config, model, lang, isPersonF, isPersonJ, lock, sdoc, askDocument } = this.state;

    if (!sdoc && !askDocument) {
      return null;
    }

    const isAnyPerson = !isPersonF && !isPersonJ;

    const ead = config.ead;

    const rule = (model.document || '').length > 11 ? 'cnpj' : 'cpf';

    let label = enLang.PT_BR
      ? (isAnyPerson ? 'CPF ou CNPJ' : isPersonF ? 'CPF' : 'CNPJ')
      : 'Document ID / VAT / TAX ID';

    let suffix = ead && enLang.PT_BR ? ' do responsável financeiro' : '';

    label = `${label}${suffix}`;

    return (
      <div>
        {lang == enLang.PT_BR ?
          <Grid container spacing={0}>
            <Grid item xs={12}>
              {isAnyPerson &&
                <FieldText
                  id='document'
                  disabled={lock}
                  label={<Translate term={label} />}
                  validation={lang == enLang.PT_BR ? 'required|' + rule : 'required|min:3|max:32'}
                  value={model.document}
                  mask={lang == enLang.PT_BR ? 'cpfCnpj' : null}
                  inputProps={{
                    className: `theme-input ${lock ? 'disabledField' : ''}`,
                    pattern: '[0-9]*',
                    inputMode: 'numeric',
                    type: 'tel'
                  }}
                  InputLabelProps={{
                    className: 'theme-label',
                    id: 'label-credit-card-document'
                  }}
                  onChange={this.setDocument}
                />
              }
              {isPersonF &&
                <FieldText
                  id='document'
                  disabled={lock}
                  label={<Translate term={label} />}
                  validation={lang == enLang.PT_BR ? 'required|cpf' : 'required|min:3|max:32'}
                  value={model.document}
                  mask={lang == enLang.PT_BR ? 'cpf' : null}
                  inputProps={{
                    className: `theme-input ${lock ? 'disabledField' : ''}`,
                    pattern: '[0-9]*',
                    inputMode: 'numeric',
                    type: 'tel'
                  }}
                  InputLabelProps={{
                    className: 'theme-label'
                  }}
                  onChange={this.setDocument}
                />
              }
              {isPersonJ &&
                <FieldText
                  id='document'
                  disabled={lock}
                  label={<Translate term={label} />}
                  validation={lang == enLang.PT_BR ? 'required|cnpj' : 'required|min:3|max:32'}
                  value={model.document}
                  mask={lang == enLang.PT_BR ? 'cnpj' : null}
                  inputProps={{
                    className: `theme-input ${lock ? 'disabledField' : ''}`,
                    pattern: '[0-9]*',
                    inputMode: 'numeric',
                    type: 'tel'
                  }}
                  InputLabelProps={{
                    className: 'theme-label'
                  }}
                  onChange={this.setDocument}
                />
              }
            </Grid>
          </Grid> :
          null
        }
      </div>
    );
  }
}